module.exports = __webpack_public_path__ + "dashboard/img/kolumna.eb2f59be6f826f903991127495789759.svg";